import ConfigsComponent from './src/components/configs'
import ReportsComponent from './src/components/reports'

export default {
   components: {
      
   },
   routes: [
      ...ConfigsComponent.routes,
      ...ReportsComponent.routes,
   ],
   sub_routes: [
      ...ConfigsComponent.sub_routes,
      ...ReportsComponent.sub_routes,
   ]
}

export const RewardsNav = [
   // { 
   //    icon: 'fa fa-columns',component: 'Dashboard', name: 'Dashboard', has_permission: false
   // },
   { icon: 'fa fa-donate',component: 'RewardRule', name: 'Reward Rules', resource: 'reward_rule', has_permission: true},
   { icon: 'fa fa-gift',component: 'PromotionCoupon', name: 'Promotion Coupons', resource: 'promotion_coupon', has_permission: true},
   { icon: 'fa fa-address-card',component: 'Vouchers', name: 'Vouchers', resource: 'voucher', has_permission: true},
   { icon: 'fa fa-users',component: 'Customer', name: 'Customers', resource: 'customer', has_permission: true},
   { icon: 'fa fa-id-card-alt',component: 'VoucherCard', name: 'Voucher Cards', resource: 'voucher_card', has_permission: true},

   // { 
   //    icon: 'fa fa-chart-pie',component: 'Configs', name: 'Configs', has_permission: false,
   //    children: [
   //    ]
   // },
]